import ApiClient from '../ApiClient';

class AiAgentPromptTemplatesAPI extends ApiClient {
  constructor() {
    super('ai_agent_prompt_templates', { accountScoped: true });
  }
}

export default new AiAgentPromptTemplatesAPI();
